export default "__VITE_ASSET__67ca0844__"